import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-autouncle-tradein-trigger', observe: true })
export class AutoUncleTradeInTriggerComponent {
	constructor(private element: HTMLElement) {
		this.element.addEventListener('click', (e) => {
			e.preventDefault();
			const auws = (window as any).auws;
			if (auws && typeof auws.openModal === 'function' && auws.ModuleTypes) {
				auws.openModal(auws.ModuleTypes.TRADE_IN);
			}
		});
	}
}
